import { FC, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { RecoilRoot } from 'recoil';

import { Box, Tab, Tabs } from '@mui/material';

import { TabPanel } from 'components/shared';
import StyledTabs from 'components/shared/StyledTabs';
import PeriodAssignments from 'components/shared/Assignments/PeriodAssignments';
import { StyledStickyPaper } from 'components/shared/Paper/StyledStickyPaper';

const RosterAssignments: FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const { t } = useTranslation();

  const onChangeActiveTab = (_: React.SyntheticEvent, newTab: number) => {
    setActiveTab(newTab);
  };

  return (
    <StyledTabs>
      <StyledStickyPaper square>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={activeTab}
          onChange={onChangeActiveTab}
        >
          <Tab label={t('flexPortalCapacity.tabs.openAssignments')} value={0} />
          <Tab
            label={t(`flexPortalCapacity.tabs.completedAssignments`)}
            value={1}
          />
          <Tab
            label={t(`flexPortalCapacity.tabs.returnedAssignments`)}
            value={2}
          />
          <Tab label={t(`flexPortalCapacity.tabs.allAssignments`)} value={3} />
        </Tabs>
      </StyledStickyPaper>
      <Box px={0.75} pb={1}>
        <TabPanel
          index={0}
          value={activeTab}
          title={t('flexPortalCapacity.tabs.openAssignments')}
        >
          <PeriodAssignments statuses={['REQUESTED', 'IN_PROGRESS']} />
        </TabPanel>
        <TabPanel
          index={1}
          value={activeTab}
          title={t('flexPortalCapacity.tabs.completedAssignments')}
        >
          <PeriodAssignments statuses={['COMPLETED']} />
        </TabPanel>
        <TabPanel
          index={2}
          value={activeTab}
          title={t('flexPortalCapacity.tabs.returnedAssignments')}
        >
          <PeriodAssignments statuses={['RETURNED']} />
        </TabPanel>
        <TabPanel
          index={3}
          value={activeTab}
          title={t('flexPortalCapacity.tabs.allAssignments')}
        >
          <PeriodAssignments />
        </TabPanel>
      </Box>
    </StyledTabs>
  );
};

const RecoilRootRosterAssignments = () => (
  <RecoilRoot>
    <RosterAssignments />
  </RecoilRoot>
);

export default RecoilRootRosterAssignments;
